import { createFileRoute } from "@tanstack/react-router";

// This index route is intentionally empty.
// The documents list is rendered by the parent documents.route.tsx
// so it remains visible when a document modal is opened.
export const Route = createFileRoute("/prospects/$prospectId/documents/")({
  component: () => null
});
